import { render, staticRenderFns } from "./SelectSystem.vue?vue&type=template&id=4040df88&scoped=true&"
import script from "./SelectSystem.vue?vue&type=script&lang=js&"
export * from "./SelectSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4040df88",
  null
  
)

export default component.exports